module.exports = __webpack_public_path__ + "img/tech.9f41e8ba.png";